import axios from 'axios'
import {apiUrl} from '../../../config/env.js'
axios.defaults.withCredentials = true
export const getUser = (shainNo) => {
  return axios.post(apiUrl + '/user/selective', {
    shain_no: shainNo,
    option: [
      'ShainNo',
      'ShainName',
      'DeptId',
      'DeptName',
      'DivisionId',
      'DivisionName',
      'PostId',
      'PostName',
      'JobId',
      'JobName',
      'EmployStatusId',
      'EmployStatusName',
      'RecruitId',
      'RecruitName',
      'JoiningRouteId',
      'JoiningRouteName',
      'Birthday'
    ]
  })
}
export const getSelectMember = (AuthData, ShainNo, ShainName,
  DeptId, DivisionId, AreaId, GroupId, HireOnStart,
  HireOnEnd, PostId, PointOfTime, Retire, NoDivisionLimited) => {
  return axios.post(apiUrl + '/user/selectMember', {
    'auth_data': AuthData,
    'shain_no': ShainNo,
    'shain_name': ShainName,
    'dept_id': DeptId.map(Number),
    'division_id': DivisionId.map(Number),
    'area_id': AreaId.map(Number),
    'group_id': GroupId.map(Number),
    'hire_on_start': HireOnStart,
    'hire_on_end': HireOnEnd,
    'post_id': PostId.map(Number),
    'point_of_time': PointOfTime,
    'retire': Retire,
    'no_division_limited': NoDivisionLimited
  })
}

export const getShainInfo = (ShainNo, Option) => {
  return axios.post(apiUrl + '/user/selective', {
    'shain_no': ShainNo,
    'option': Option
  })
}

export const SelectAll = (ShainNoNone,
  ShainNo,
  PlanId,
  ShainName,
  DeptId,
  DivisionId,
  AreaId,
  GroupId,
  PostId,
  LoginRights,
  ShainNoDigest) => {
  return axios.post(apiUrl + '/user/get', {
    'shain_no_none': ShainNoNone,
    'shain_no': ShainNo,
    'plan_id': PlanId,
    'shain_name': ShainName,
    'dept_id': DeptId,
    'division_id': DivisionId,
    'area_id': AreaId,
    'group_id': GroupId,
    'post_id': PostId,
    'login_rights': LoginRights
  })
}

export const SelectOneRecord = (ShainNoDigest) => {
  return axios.post(apiUrl + '/user/selective', {
    shain_no_digest: ShainNoDigest,
    option: [
      'ShainNo',
      'PlanId',
      'ShainName',
      'DivisionName',
      'PostName',
      'PostSortOrder',
      'OfficeName',
      'RetireOn',
      'Birthday'
    ]
  })
}

export const getUserMaster = (hash) => {
  return axios.get(apiUrl + '/user/master/' + hash)
}

export const getPostSort = (ShainNo, Data) => {
  return axios.post(apiUrl + '/user/selective', {
    shain_no: ShainNo,
    option: Data
  })
}

export const getExportUser = (ShainNoNone,
  ShainNo,
  PlanId,
  ShainName,
  DeptId,
  DivisionId,
  AreaId,
  GroupId,
  PostId,
  LoginRights,
  LoginRightsList) => {
  return axios.post(apiUrl + '/user/export', {
    'shain_no_none': ShainNoNone,
    'shain_no': ShainNo,
    'plan_id': PlanId,
    'shain_name': ShainName,
    'dept_id': DeptId,
    'division_id': DivisionId,
    'area_id': AreaId,
    'group_id': GroupId,
    'post_id': PostId,
    'login_rights': LoginRights,
    'login_rights_list': LoginRightsList
  })
}

export const SelectUserModal = (
  authData, divisionConf, postConf, retireConf, shainName) => {
  return axios.post(apiUrl + '/selectUser/modal', {
    auth_data: authData,
    division_conf: divisionConf,
    post_conf: postConf,
    retire_conf: retireConf,
    shain_name: shainName
  })
}

export const AutoInputUserName = (
  authData, divisionConf, postConf, retireConf, shainNo) => {
  return axios.post(apiUrl + '/autoInputUserName', {
    auth_data: authData,
    division_conf: divisionConf,
    post_conf: postConf,
    retire_conf: retireConf,
    shain_no: shainNo
  })
}

export const UserMasterShowSearch = () => {
  return axios.get(apiUrl + '/user/master')
}



// WEBPACK FOOTER //
// ./src/api/user/index.js